import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import file_icon from '../assets/images/files-icon.jpg'
import { useParams } from 'react-router-dom';
import { Avatar, } from '@mui/material';

import AgenciesHook from '../hooks/AgenciesHook'
export default function AgencyProfileDetails() {
    const { id } = useParams()

    const { getAgencyDetails, profile } = AgenciesHook()
    const collapsed = useSelector((state) => state.collapsed.collapsed);
    const [activeStatus, setActiveStatus] = useState(0);
    //getting agency profile details
    useEffect(() => {
        getAgencyDetails(id)

    }, [id])

    // Uploading Files
    const documents = profile && profile.documents
    const focal_persons = profile && profile.focal_persons
    const social_links = profile && profile.social_links

    return (
        <div className={`${collapsed ? 'collapsed mt-5' : 'main mt-5'}`}>
            <div className="container-fluid bg-none my-0 mt-4">
                <div className="row px-2 mt-5 pt-4 packages">
                    <div className="col-md-12 data_table p-2 py-auto my-auto header_section">
                        <div className="profile_setting border m-2">
                            <div className="top_section py-5 m-0" />
                            <div className="bottom_section m-0">
                                <div className="justify-content-between px-2 mb-2">
                                    <div className="d-flex align-items-center">
                                        <div className="profile_pic">

                                            <img src={profile.profile_pic} alt="" />

                                        </div>
                                        <div className="profile_details p-1">
                                            <h4>{profile && profile.name} <span className={`${profile && profile.isActive ? 'text-success' : 'text-danger'}`}>{profile && profile.isActive ? "Approved" : 'Pending'}</span> </h4>
                                            <span className="mt-0 pt-0">Company Registration No</span>
                                            <p>{profile && profile.reg_no}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex justify-content-between py-1 px-2">
                            <div className="d-flex left">
                                <div className="btn-group rounded" role="group" aria-label="Basic example">
                                    <button
                                        type="button"
                                        className={`py-2 px-3 rounded-start ${activeStatus === 0 && 'active'}`}
                                        onClick={() => setActiveStatus(0)}
                                    >
                                        Contact Details
                                    </button>
                                    <button
                                        type="button"
                                        className={`py-2 px-3 rounded-start ${activeStatus === 1 && 'active'}`}
                                        onClick={() => setActiveStatus(1)}
                                    >
                                        Focal Persons
                                    </button>
                                    <button
                                        type="button"
                                        className={`py-2 px-3 rounded-start ${activeStatus === 2 && 'active'}`}
                                        onClick={() => setActiveStatus(2)}
                                    >
                                        Social Links
                                    </button>
                                    <button
                                        type="button"
                                        className={`py-2 px-3 rounded-end ${activeStatus === 3 && 'active'}`}
                                        onClick={() => setActiveStatus(3)}
                                    >
                                        Document Management
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {activeStatus === 0 && (
                        <div className="col-md-12 data_table p-2 pt-1 pb-3 mt-3 my-auto mx-auto new_package">
                            <div className="row  px-3 mt-3">
                                <div className="d-flex justify-content-between px-1 info_header">
                                    <div className="left">
                                        <h4 className="mb-3">Personal Information</h4>
                                    </div>
                                </div>
                                <hr />
                            </div>
                            <div className="row mt-3 mb-1 px-3">

                                <div className="col-md-4 px-1 my-2">
                                    <label htmlFor="name">Agency Name</label>
                                    <input
                                        type="text"
                                        name="name"
                                        value={profile && profile.name}
                                        readOnly
                                        placeholder="Name here"
                                    />
                                </div>
                                <div className="col-md-4 px-1 my-2">
                                    <label htmlFor="reg_no">Agency Registration No</label>
                                    <input
                                        type="text"
                                        name="reg_no"
                                        value={profile && profile.reg_no}
                                        readOnly
                                        placeholder="Registration No"
                                    />
                                </div>
                                <div className="col-md-4 px-1 my-2">
                                    <label htmlFor="address">Agency Address</label>
                                    <input
                                        type="text"
                                        name="address"
                                        value={profile && profile.address}
                                        readOnly
                                        placeholder="Address"
                                    />
                                </div>

                            </div>
                            <hr />

                            <div className="row mt-3 mb-1 px-3">
                                <h5 className="mb-2">Contact Informations</h5>
                                <div className="col-md-3 px-1 my-2">
                                    <label htmlFor="email">Email</label>
                                    <input
                                        type="email"
                                        name="email"
                                        value={profile && profile.email}
                                        readOnly
                                        placeholder="Email here"
                                    />
                                </div>
                                <div className="col-md-3 px-1 my-2">
                                    <label htmlFor="phone">Phone Number</label>
                                    <input
                                        type="number"
                                        name="phone"
                                        value={profile && profile.phone}
                                        readOnly
                                        placeholder="Phone here"
                                    />
                                </div>
                                <div className="col-md-3 px-1 my-2">
                                    <label htmlFor="additional_phone">Additional Phone</label>
                                    <input
                                        type="number"
                                        name="additional_phone"
                                        value={profile && profile.additional_phone}
                                        readOnly
                                        placeholder="Additional Phone"
                                    />
                                </div>
                                <div className="col-md-3 px-1 my-2">
                                    <label htmlFor="whatsapp_phone">WhatsApp Phone</label>
                                    <input
                                        type="number"
                                        name="whatsapp_phone"
                                        value={profile && profile.whatsapp_phone}
                                        readOnly
                                        placeholder="WhatsApp Number"
                                    />
                                </div>

                                <div className="col-md-3 px-1 my-2">
                                    <label htmlFor="munazam_name">Munazzam Name</label>
                                    <input
                                        type="text"
                                        name="munazam_name"
                                        value={profile && profile.munazam_name}
                                        readOnly
                                        placeholder="Munazzam Name"
                                    />
                                    </div>

                                    <div className="col-md-3 px-1 my-2">
                                    <label htmlFor="province">Province</label>
                                    <input
                                        type="text"
                                        name="province"
                                        value={profile && profile.province}
                                        readOnly
                                        placeholder="Province"
                                    />
                                    </div>

                                    <div className="col-md-3 px-1 my-2">
                                    <label htmlFor="district">District/City</label>
                                    <input
                                        type="text"
                                        name="district"
                                        value={profile && profile.district}
                                        readOnly
                                        placeholder="District"
                                    />
                                    </div>

                            </div>
                            <hr />





                        </div>
                    )}


                    {activeStatus === 1 &&
                        <div className='col-md-12 focal_persons px-1 mb-2'>

                            <div className="row mt-3 px-0">
                                {focal_persons && focal_persons.map((data, index) => (
                                    <div className="col-md-3">
                                        <div className="person_card shadow-sm bg-white rounded pb-4 pt-1">

                                            <div className="image mx-auto pt-2 rounded-circle">
                                                <Avatar className="mx-auto avatar" sx={{ height: 60, width: 60 }}>{data.name.slice(0, 1)}</Avatar>
                                            </div>
                                            <div className="text-center mt-3">
                                                <h6 className="person-name">{data.name}</h6>
                                                <p className="person-info">Email: {data.email}</p>
                                                <p className="person-info">Phone: {data.phone}</p>
                                                <p className="person-info">City: {data.city}</p>
                                            </div>

                                        </div>
                                    </div>
                                ))}

                            </div>




                        </div>

                    }



                    {activeStatus === 2 &&
                        <div className='col-md-12 documents'>
                            <div className="row mt-3">
                                {social_links && social_links.filter(d => !d.isDeleted).map((data, index) => (
                                    <div className='col-md-12 d-flex justify-content-between my-1 new_package data_table px-3 py-2 ' key={index} >
                                        <div className="left my-auto">
                                            <h6 className='my-auto'>{data.platform}</h6>
                                        </div>
                                        <div className="right my-auto d-flex justify-content-between file_details py-2 px-2">

                                            <div className="left d-flex my-auto me-5">

                                                <a className='my-auto' href={data.link} target='_blank' rel='noreferrer'>{data.link}</a>
                                            </div>


                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                    }
                    {activeStatus === 3 &&
                        <div className='col-md-12 documents'>

                            <div className="row  mt-1">
                                {documents && documents.filter(d => !d.isDeleted).map((data, index) => (
                                    <div className='col-md-12 d-flex justify-content-between my-1 new_package data_table px-3 py-2 ' key={index} >
                                        <div className="left my-auto">
                                            <h6 className='my-auto'>{data.file_name}</h6>
                                        </div>
                                        <div className="right my-auto d-flex justify-content-between file_details py-2 px-2">

                                            <div className="left d-flex my-auto me-5">
                                                <img src={file_icon} alt="" className='my-auto' />
                                                <p className='my-auto'>{data.selected_file_name}</p>
                                            </div>
                                            <div className="right my-auto d-flex ms-5">
                                                <div className="btn-group" role="group" aria-label="Basic example">


                                                    <button onClick={() => {
                                                        if (data.file_url) {
                                                            window.open(data.file_url, '_blank');
                                                        } else {
                                                            console.error('File URL is not available');
                                                        }
                                                    }}>
                                                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M18.1959 9.4915C18.4527 9.85157 18.5811 10.0316 18.5811 10.2981C18.5811 10.5646 18.4527 10.7446 18.1959 11.1047C17.0422 12.7226 14.0956 16.2103 10.1352 16.2103C6.17466 16.2103 3.22814 12.7226 2.07438 11.1047C1.8176 10.7446 1.68921 10.5646 1.68921 10.2981C1.68921 10.0316 1.8176 9.85157 2.07438 9.4915C3.22814 7.87364 6.17466 4.38594 10.1352 4.38594C14.0956 4.38594 17.0422 7.87364 18.1959 9.4915Z" stroke="#6D76A1" stroke-width="1.52027" />
                                                            <path d="M12.6689 10.2981C12.6689 8.89872 11.5345 7.76431 10.1351 7.76431C8.73573 7.76431 7.60132 8.89872 7.60132 10.2981C7.60132 11.6975 8.73573 12.8319 10.1351 12.8319C11.5345 12.8319 12.6689 11.6975 12.6689 10.2981Z" stroke="#6D76A1" stroke-width="1.52027" />
                                                        </svg>
                                                    </button>


                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="row">
                                <div className="col-md-12 data_table py-2 px-3 mt-2 mb-1 my-auto mx-auto">
                                    <p className='mt-2'>Following documents are required to verify agency account:-</p>
                                    <ul>
                                        <li>Recognition Letter</li>
                                        <li>SECP Certificate (Incorportaion Certificate)</li>
                                        <li>Munazim Card</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                    }

                </div>
            </div>
        </div>
    );
}
